import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {firstNestedSymbolControl, Fliesstext} from '../../models/uiArtefakt';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {ShellConfigService} from '../../services/shell-config.service';
import {DeviceService, ISymbol, TranslationService} from '@lv1871/core';
import {TextAusrichtung} from '../../models/textAusrichtung';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'lv-fliesstext',
    templateUrl: './fliesstext.component.html',
    styleUrls: ['./fliesstext.component.scss'],
    standalone: false
})
export class FliesstextComponent implements OnInit, AfterViewInit  {

  @Input()
  public uiArtefakt: Fliesstext;

  public uiAusrichtung: UIAusrichtung;
  public textAusrichtung: TextAusrichtung = TextAusrichtung.TEXTAUSRICHTUNG_LINKSBUENDIG;
  public nestedSymbol: ISymbol;
  public showInfo: boolean = false;

  public mobile: boolean = false;
  constructor(private _shellConfigService: ShellConfigService, private _snackBar: MatSnackBar, private _deviceService: DeviceService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public toggleInfo() {
    this.showInfo = !this.showInfo;
  }

  public ngOnInit(): void {
    this.mobile = this._deviceService.isMobileDevice;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
  }

  public onMobileClick() {
    if (this.mobile) {
      this._snackBar.open(this.uiArtefakt.InfoTextTooltipCollapsable, '', {
        duration: 5000,
        panelClass: 'lv-snackbar-mobile-label-tooltip'
      });
    }
  }

}
